import {
  CreateStoppageReasonCommand,
  StoppageReasonsApi,
  UpdateStoppageReasonCommand,
} from '@operations/app/api'
import { createApiClient } from '@operations/app/http-client'

class StoppageReasonService {
  httpClient = createApiClient(StoppageReasonsApi)

  getStoppageReasons = async () => {
    const { data } = await this.httpClient.get()
    return data
  }

  getById = async (id: number) => {
    const { data } = await this.httpClient.getById(id)
    return data
  }

  create = async (cmd: CreateStoppageReasonCommand) => {
    await this.httpClient.create(cmd)
  }

  update = async (cmd: UpdateStoppageReasonCommand) => {
    await this.httpClient.update(cmd)
  }
  delete = async (id: number) => {
    await this.httpClient._delete(id)
  }
}
const stoppageReasonService = new StoppageReasonService()
export default stoppageReasonService
